/* eslint-disable max-len */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { Observable, ReplaySubject, Subscription } from 'rxjs';
import { MapsService } from '../../maps.service';
import _ from 'lodash';
import { BadgeOptions, badgeColorCode } from 'app/components/badge/badge.interface';
import { DateTimePipe } from 'app/core/pipes/datetimeformator.pipe';
import * as dayjs from 'dayjs';
import * as moment from 'moment';
import isBetween from 'dayjs/plugin/isBetween';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { MatCalendarCellClassFunction } from '@angular/material/datepicker';
import { MatDatepicker } from '@angular/material/datepicker';
import { RouteFormOptions } from 'app/components/route-form/route-form.types';
import { ViewHistoryComponent } from 'app/components/view-history/view-history.component';
import { Router } from '@angular/router';
import { distinctUntilChanged, debounceTime, switchMap } from 'rxjs/operators';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { priority } from 'app/core/constants/constants';




@Component({
  selector: 'app-map-sidebar',
  templateUrl: './map-sidebar.component.html',
  styleUrls: ['./map-sidebar.component.scss']
})
export class MapSidebarComponent implements OnInit, OnDestroy {

  @Input()isShown: boolean;
  @Output()mapview: EventEmitter<any> = new EventEmitter<any>();
  @Output()sidebar: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('employeeListing')employeeListing: ElementRef;
  @ViewChild('employeeFilterRef')employeeFilterRef: ElementRef;
  @ViewChild('assetListing')assetListing: ElementRef;
  @ViewChild('JobListing') jobListing: ElementRef;
  @ViewChild('propertyListing')propertyListing: ElementRef;
  @ViewChild('routeDatePicker')routeDatePicker: MatDatepicker<Date>;
  @ViewChild('routeDatePickerContainer')routeDatePickerContainer: ElementRef;


  modules: any = {
    'EMPLOYEE'     : 'text.users',
    'JOBS'         : 'text.jobs',
    'ROUTES'       : 'text.routes',
    'ASSETS'       : 'text.assets',
    'PROPERTY'     : 'text.property',
    'CUSTOMER'     : 'customers.text',
    'ORGANIZATION' : 'text.organizations'
  };

  markerStatus: any = {
    'EMPLOYEE'     : true,
    'JOBS'         : true,
    'ROUTES'       : true,
    'ASSETS'       : true,
    'PROPERTY'     : true,
    'CUSTOMER'     : true,
    'ORGANIZATION' : true
  };

  assetStatus = {
    'INSTALLED' : 'Installed',
    'READY_TO_INSTALL' : 'Ready to Install',
    'UNDER_SERVICE' : 'Under Service',
    'REMOVED' : 'Removed',
    'OBSOLETE' : 'Obsolete'
  };
  dateFormat: any = 'YYYY-MM-DD';
  count: number = 20;

  //Employee Variables
  allTeams: Array<any> = [];
  allTeamsCopy: Array<any> = [];
  allUsers: Array<any> = [];
  allOriginalUsers: Array<any> = [];
  allLocationData:  Array<any> = [];
  onlineCount: number = 0;
  offlineCount: number = 0;
  selectedTeam: string;
  employeeCurrentPage = 1;
  employeeTotalPage = 1;
  employeeTotalRecords = 0;
  isLoading: boolean = false;
  isInitLoading: boolean = false;
  showOnline: boolean = false;
  searchEmployeeKey: string;
  onlineUsers: string;
  isUserDataLoadedInit: boolean = false;
  employeeFilter: boolean = false;
  employeeFilterCount: number = 0;
  filterUserStatus: 'ALL' | 'ONLINE' | 'OFFLINE' = 'ALL';
  onlineUserLocationData: any;
  onlineUserUids: any[] = [];

  //Assets Variables
  searchAssetKey: string;
  allAssetCategory: Array<any> = [];
  selectedAssetCategory: string = '';
  allAssets: Array<any> = [];
  assetCurrentPage = 1;
  assetTotalPage: number = 1;
  assetTotalRecords: number = 0;
  assetFilter: boolean = false;
  assetFilterCount: number = 0;

  searchPropertyKey: string;
  allProperties: Array<any> = [];
  propertyCurrentPage: number = 1;
  propertyTotalPage: number = 1;
  propertyTotalRecords: number = 0;
  propertyFilter: boolean = false;
  propertyFilterCount: number;

  searchJobKey: string;
  allJobs: Array<any> = [];
  jobCurrentPage: number = 1;
  jobTotalRecords: number = 0;
  jobTotalPages: number = 1;
  jobFilter: boolean = false;
  jobFilterCount: number;
  jobTabTeamSearchSubscription: Subscription;
  jobFilterParams = ['filter.assigned_to', 'filter.assigned_to_team', 'filter.keyword'];
  jobTeamFilterSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  jobTabFilters = { allTeams: [], allUsers: [], teamsTotalPages: 1, teamsCurrentPage: 1, isLoading: { teams: false, users: false }, jobFilter: {}, teamsResetBlocker: false, teamsSearchKeywoard: '', selectedTeam: null, selectedUser: null, teamFilterUid: '' };

  searchOrganizationKey: string;
  allOrganizations: Array<any> = [];
  organizationCurrentPage: number = 1;
  organizationTotalPage: number = 1;
  organizationTotalRecords: number = 0;
  organizationFilter: boolean = false;
  organizationFilterCount: number;

  searchCustomerKey: string;
  allCustomers: Array<any> = [];
  customerCurrentPage: number = 1;
  customerTotalPage: number = 1;
  customerTotalRecords: number = 0;
  customerFilter: boolean = false;
  customerFilterCount: number;

  searchRouteKey: string;
  searchDate: any = moment();
  allRoutes: Array<any> = [];
  routesCurrentPage: number = 1;
  routesTotalPage: number = 1;
  routesTotalRecords: number = 0;
  routesFilter: boolean = false;
  routesFilterCount: number = 1;
  currentFromRoutesDate: string | Date = dayjs().format('YYYY-MM-DD');
  currentToRoutesDate: string | Date = dayjs().format('YYYY-MM-DD');
  allRouteCount: any;
  routeFormOption: RouteFormOptions = {
    state: 'new',
    header: 'route.create'
  };
  openNewRoute: boolean = false;
  openRouteDetails: boolean = false;
  currentRoute: any;
  toggleDetails: boolean = false;
  currentRouteUid: string;

  currentTab: string = '';
  showFilterBadge: boolean = false;
  currentTabSubscription: Subscription;

  companyConfig: any;

  routeDetailSubscription: Subscription;
  updateListSubscription: Subscription;

  constructor(
    private _MapService: MapsService,
    private _DataCollectorService: DataCollectorService,
    private _toast: HotToastService,
    private _dateTime: DateTimePipe,
    private _LocalStorageService: LocalStorageService,
    private _zuperDialogService: ZuperDialogService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _zuperDrawerService: ZuperDrawerService,
    private _router: Router,
    public _utilityService: UtilityService
    ) { }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
      if ((moment(cellDate).date() === 1) &&
          (view === 'month')
         )
      {
         this.changeMonth(cellDate);
      };
      return '';
  };

  changeMonth(date: any): void {
    this.getRoutesCount(date);
  }

  openJobPopup(event: Event, data?: any, canEdit?: boolean ): void {
    event?.preventDefault();
    event?.stopPropagation();
    const previewData = {
      'uid' : data.job_uid,
      'module' : 'JOB',
    };
    if(canEdit){
      previewData['canEdit'] = canEdit;
    }
    this._MapService.previewUid.next(previewData);
  }

  getTotalScheduledDurationHours(minutes: number): number{
    return Math.floor(minutes / 60);
  }

  getTab(): void{
    this.currentTabSubscription = this._MapService.tab.subscribe((res)=>{
      this.currentTab = res;
      if(this.currentTab !== this._MapService.prevTab){
        this._MapService.previewUid.next(false);
      }
      const status_data = {
        modules : this.modules,
        states : this.markerStatus,
        current_tab : this.currentTab
      };
      this._MapService.markerStatus.next(status_data);
      this._LocalStorageService.setLocalStorage('maps_marker_status',status_data);
      this.toggleDetails = false;
      const drawer = this._zuperDrawerService.getComponent('routeDetails');
      if(drawer){
        drawer.close();
      }
      if(this.routeDetailSubscription?.unsubscribe){
        this.routeDetailSubscription.unsubscribe();
      }
      if(this.currentTab === 'EMPLOYEE' && this.currentTab !== this._MapService.prevTab){
        this.selectedTeam = null;
        this.searchEmployeeKey = '';
        this.allUsers = [];
        this.employeeCurrentPage = 1;
        let filter = {
          limit : this.count,
          page: this.employeeCurrentPage
        };
        const local_filter = this._LocalStorageService.getLocalStorage('map_employee_filter');
        if(local_filter){
          filter = local_filter;
          this.filterUserStatus = local_filter?.['user_status'] || 'ALL';
          if(local_filter?.['filter.keyword']){
            this.searchEmployeeKey = local_filter['filter.keyword'];
          }
          if(local_filter?.team_uid){
            this.selectedTeam = local_filter.team_uid;
          }
        }

        this.onUserFilterChange();
      }else if(this.currentTab === 'ASSETS' && this.currentTab !== this._MapService.prevTab){
        this.selectedAssetCategory = '';
        this.searchAssetKey = '';
        this.allAssets = [];
        this.assetCurrentPage = 1;
        if(this.allAssetCategory?.length === 0){
          this.getAssetCategory();
        }
        let filter = {
          count : this.count,
          page: this.assetCurrentPage
        };
        const local_filter = this._LocalStorageService.getLocalStorage('map_asset_filter');
        if(local_filter){
          filter = local_filter;
          if(local_filter?.['filter.keyword']){
            this.searchAssetKey = local_filter['filter.keyword'];
          }
          if(local_filter?.['filter.asset_category']){
            this.selectedAssetCategory = local_filter['filter.asset_category'];
          }
        }
        this.getAllAssets(filter);
      }else if(this.currentTab === 'PROPERTY' && this.currentTab !== this._MapService.prevTab)
      {
        this.allProperties = [];
        this.propertyCurrentPage = 1;
        this.searchPropertyKey = '';
        let filter = {
          count : this.count,
          page: this.propertyCurrentPage
        };
        const local_filter = this._LocalStorageService.getLocalStorage('map_property_filter');
        if(local_filter){
          filter = local_filter;
          if(local_filter?.['filter.keyword']){
            this.searchPropertyKey = local_filter['filter.keyword'];
          }
        }
        this.getAllProperties(filter);
      }
      else if(this.currentTab === 'JOBS' && this.currentTab !== this._MapService.prevTab){
        this.allJobs = [];
        this.jobCurrentPage = 1;
        this.searchJobKey = '';
        let filter = {
          count : this.count,
          page : this.jobCurrentPage
        };
        const local_filter = this._LocalStorageService.getLocalStorage('map_job_filter');
        if(local_filter){
          filter = _.merge({}, local_filter, filter);
          if(local_filter?.['filter.keyword']){
            this.searchJobKey = local_filter['filter.keyword'];
          }
        }
        this.jobTabFilters.selectedTeam = local_filter?.['filter.assigned_to_team'] || null;
        this.jobTabFilters.teamFilterUid = local_filter?.['filter.assigned_to_team'] || '';
        this.jobTabFilters.selectedUser = local_filter?.['filter.assigned_to'] || null;
        this.getJobTabTeamSummary(filter, true);
      }else if(this.currentTab === 'ORGANIZATION' && this.currentTab !== this._MapService.prevTab){
        this.allOrganizations = [];
        this.organizationCurrentPage = 1;
        this.searchOrganizationKey = '';
        let filter = {
          count : this.count,
          page : this.organizationCurrentPage
        };
        const local_filter = this._LocalStorageService.getLocalStorage('map_organization_filter');
        if(local_filter){
          filter = local_filter;
          if(local_filter?.['filter.keyword']){
            this.searchOrganizationKey = local_filter['filter.keyword'];
          }
        }
        this.getAllOrganizations(filter);
      }else if(this.currentTab === 'CUSTOMER' && this.currentTab !== this._MapService.prevTab){
        this.allCustomers = [];
        this.customerCurrentPage = 1;
        this.searchCustomerKey = '';
        let filter = {
          count : this.count,
          page : this.customerCurrentPage
        };
        const local_filter = this._LocalStorageService.getLocalStorage('map_customer_filter');
        if(local_filter){
          filter = local_filter;
          if(local_filter?.['filter.keyword']){
            this.searchCustomerKey = local_filter['filter.keyword'];
          }
        }
        this.getAllCustomers(filter);
      }else if(this.currentTab === 'ROUTES' && this.currentTab !== this._MapService.prevTab){
        this.allRoutes = [];
        this.routesCurrentPage = 1;
        this.searchRouteKey = '';
        this.searchDate = moment();
        this.currentFromRoutesDate = this.searchDate.format('YYYY-MM-DD');
        this.currentToRoutesDate = this.searchDate.format('YYYY-MM-DD');
        let filter = {
          limit : this.count,
          page : this.routesCurrentPage,
          from_date : this.currentFromRoutesDate,
          to_date : this.currentToRoutesDate
        };
        // const local_filter = this._LocalStorageService.getLocalStorage('map_routes_filter');
        // if(local_filter){
        //   filter = local_filter;
        //   if(local_filter?.['filter.keyword']){
        //     this.searchRouteKey = local_filter['filter.keyword'];
        //   }
        //   if(local_filter?.['from_date']){
        //     this.currentFromRoutesDate = local_filter?.['from_date'];
        //     this.searchDate = moment(local_filter?.['from_date'], 'YYYY-MM-DD');
        //   }
        //   if(local_filter?.['to_date']){
        //     this.currentToRoutesDate = local_filter?.['to_date'];
        //   }
        // }
        this.getAllRoutes(filter);
        if(this.routeDetailSubscription?.unsubscribe){
          this.routeDetailSubscription.unsubscribe();
        }
        this.routeDetailSubscription = this._MapService.routeDetailChange.subscribe(
          (response: any) => {
            if(response?.departure && (this.currentFromRoutesDate !== moment(response?.departure).format('YYYY-MM-DD'))){
              this.allRoutes = [];
              this.routesCurrentPage = 1;
              this.searchRouteKey = '';
              this.searchDate = moment(response?.departure);
              this.currentFromRoutesDate = this.searchDate.format('YYYY-MM-DD');
              this.currentToRoutesDate = this.searchDate.format('YYYY-MM-DD');
              filter = {
                limit : this.count,
                page : this.routesCurrentPage,
                from_date : this.currentFromRoutesDate,
                to_date : this.currentToRoutesDate
              };
              this.getAllRoutes(filter);
            }else{
              const found = this.allRoutes.findIndex((route: any) => (route?.route_uid === response?.route_uid));
              if(found > -1){
                this.allRoutes[found] = response;
              }
              this._MapService.routeLocationData.next({
                state: 'listing',
                data: this.allRoutes,
                drawerClosed: true
              });
              this.currentRoute = null;
            }
          }
        );

      }
    });
  }

  toggleNewRoute(): void {
    const drawer = this._zuperDrawerService.getComponent('routeDetails');
    if(drawer){
      drawer.close();
    }
    this.routeFormOption = {
      state: 'new',
      header: 'route.create'
    };
    this.openNewRoute = true;
    this.currentRoute = null;
  }

  toggleEditRoute(route: any): void {
    const drawer = this._zuperDrawerService.getComponent('routeDetails');
    if(drawer){
      drawer.close();
    }
    this.currentRoute = null;
    this.openNewRoute = false;
    this.routeFormOption = {
      state: 'edit',
      header: 'route.edit'
    };
    this.getRouteDetails(route, 'edit');
  }

  toggleCloneRoute(route: any): void {
    const drawer = this._zuperDrawerService.getComponent('routeDetails');
    if(drawer){
      drawer.close();
    }
    this.openNewRoute = false;
    this.routeFormOption = {
      state: 'clone',
      header: 'text.clone_route'
    };
    this.getRouteDetails(route, 'new');
  }

  getRouteDetails(route: any, state?: 'edit' | 'new' | 'view'): void {
    this._DataCollectorService.getData(this._MapService.mapsAPi.getRoutes + '/' + route?.route_uid)
      .subscribe((res: any) => {
        this.currentRoute = res?.data;
        if(state === 'edit') {
          this.openNewRoute = true;
        }else if (state === 'new') {
          this.openNewRoute = true;
        }
      },(err: any) => {

      });
  }

  onNewActionComplete(event: any): void {
    if(event?.completed){
      if(event?.data?.departure){
        this.searchDate = moment(dayjs.utc(event?.data?.departure, 'YYYY-MM-DD HH:mm:ss').tz(this._utilityService.timeZone).format('YYYY-MM-DD'), 'YYYY-MM-DD');
      }
      this.routeDateChange();
    }else{
      this.openNewRoute = false;
      this.currentRoute = null;
    }
  }

  getMarkerStatus(module): string{
    if(this.markerStatus[module]){
      return 'rgb(224, 176, 255)';
    }else{
      return 'none';
    }
  }

  pinMarkers(module): void{
    this.markerStatus[module] = !this.markerStatus[module];
    const status_data = {
      modules : this.modules,
      states : this.markerStatus,
      current_tab : this.currentTab
    };
    this._LocalStorageService.setLocalStorage('maps_marker_status',status_data);
  }

  checkBadge(): boolean{
    if(this.currentTab === 'JOBS'){
      if(this.jobFilterCount === 0){
        return false;
      }else{
        return true;
      }
    }else if(this.currentTab === 'ASSETS'){
      if(this.assetFilterCount === 0){
        return false;
      }else{
        return true;
      }
    }else if(this.currentTab === 'PROPERTY'){
      if(this.propertyFilterCount === 0){
        return false;
      }else{
        return true;
      }
    }else if(this.currentTab === 'EMPLOYEE'){
      if(this.employeeFilterCount === 0){
        return false;
      }else{
        return true;
      }
    }
    else if(this.currentTab === 'ORGANIZATION'){
      if(this.organizationFilterCount === 0){
        return false;
      }else{
        return true;
      }
    }else if(this.currentTab === 'CUSTOMER'){
      if(this.customerFilterCount === 0){
        return false;
      }else{
        return true;
      }
    }else if(this.currentTab === 'ROUTES'){
      if(this.routesFilterCount === 0){
        return false;
      }else{
        return true;
      }
    }
  }

  getJobPriorityBadgeOptions(job): BadgeOptions{
    // let priority  = job.job_priority.charAt(0)+(job.job_priority.toLowerCase().split('').splice(1).join(''))
    if(job?.job_priority){
      return {
        type: job.job_priority,
        displayKey: priority[job.job_priority],
        displayName: job.job_priority.toLowerCase(),
        extraClass: 'capitalize'
      };
    }
  }

  getJobStatusOptions(status: any): BadgeOptions {
    const badgeOption: BadgeOptions = {
      type: status?.status_name,
      color: status?.status_color || badgeColorCode[status?.status_type],
      displayName: status?.status_name,
      extraClass: 'capitalize'
    };
    return badgeOption;
  }

  getJobStatusBadgeOptions(job): BadgeOptions{
    if(job?.current_job_status){
      return {
        type: null,
        displayKey: null,
        displayName: job.current_job_status.status_name,
        color: job.current_job_status.status_color
      };
    }
  }

  getHeaderBadgeOptions(module): BadgeOptions{
    if(module === 'EMPLOYEE'){
      const employeeCount = this.filterUserStatus === 'ALL' ? this.employeeTotalRecords : this.filterUserStatus === 'ONLINE' ? this.onlineCount : this.offlineCount;
      return {
        type: 'PRIMARY',
        displayKey: null,
        displayName: employeeCount,
        displayType: 'listingCount'
      };
    }else if(module === 'ASSETS'){
      return {
        type: 'PRIMARY',
        displayKey: null,
        displayName: this.assetTotalRecords,
        displayType: 'listingCount'
      };
    }else if(module === 'PROPERTY'){
      return {
        type: 'PRIMARY',
        displayKey: null,
        displayName: this.propertyTotalRecords,
        displayType: 'listingCount'
      };
    }else if(module === 'JOBS'){
      return {
        type: 'PRIMARY',
        displayKey: null,
        displayName: this.jobTotalRecords,
        displayType: 'listingCount'
      };
    }
    else if(module === 'ORGANIZATION'){
      return {
        type: 'PRIMARY',
        displayKey: null,
        displayName: this.organizationTotalRecords,
        displayType: 'listingCount'
      };
    }
    else if(module === 'CUSTOMER'){
      return {
        type: 'PRIMARY',
        displayKey: null,
        displayName: this.customerTotalRecords,
        displayType: 'listingCount'
      };
    }
    else if(module === 'ROUTES'){
      return {
        type: 'PRIMARY',
        displayKey: null,
        displayName: this.routesTotalRecords,
        displayType: 'listingCount'
      };
    }
    else{
      return {
        type: 'PRIMARY',
        displayKey: null,
        displayName: 0,
        displayType: 'listingCount'
      };
    }
  }

  getBadgeOptions(module): BadgeOptions {
    if(module === 'EMPLOYEE'){
      return {
        type: 'PRIMARY',
        displayKey: null,
        displayName: this.employeeFilterCount,
        displayType: 'listingCount'
      };
    }else if(module === 'ASSETS'){
      return {
        type: 'PRIMARY',
        displayKey : null,
        displayName : this.assetFilterCount,
        displayType: 'listingCount'
      };
    }else if(module === 'PROPERTY'){
      return{
        type : 'PRIMARY',
        displayKey : null,
        displayName : this.propertyFilterCount,
        displayType: 'listingCount'
      };
    }else if(module === 'JOBS'){
      return{
        type : 'PRIMARY',
        displayKey : null,
        displayName : this.jobFilterCount,
        displayType: 'listingCount'
      };
    }
    else if(module === 'ORGANIZATION'){
      return{
        type : 'PRIMARY',
        displayKey : null,
        displayName : this.organizationFilterCount,
        displayType: 'listingCount'
      };
    }
    else if(module === 'CUSTOMER'){
      return{
        type : 'PRIMARY',
        displayKey : null,
        displayName : this.customerFilterCount,
        displayType: 'listingCount'
      };
    }
    else if(module === 'ROUTES'){
      return{
        type : 'PRIMARY',
        displayKey : null,
        displayName : this.routesFilterCount,
        displayType: 'listingCount'
      };
    }
    else{
      return {
        type: 'PRIMARY',
        displayKey: null,
        displayName: 0,
        displayType: 'listingCount'
      };
    }
  }

  loadMore(module): void{
    if(module === 'EMPLOYEE'){
      this.employeeCurrentPage++;
      const filter = {
        'team_uid': (this.selectedTeam) ? this.selectedTeam : '',
        'limit': this.count,
        'page': this.employeeCurrentPage
      };
      if(this.searchEmployeeKey){
        filter['filter.keyword'] = this.searchEmployeeKey;
      }
      this.getAllUsers(filter,true);
    }else if(module === 'ASSETS'){
      this.assetCurrentPage++;
      const filter = {
        count : this.count,
        page : this.assetCurrentPage
      };
      if(this.selectedAssetCategory){
        filter['filter.asset_category'] = this.selectedAssetCategory;
      }
      this.getAllAssets(filter);
    }else if(module === 'PROPERTY'){
      this.propertyCurrentPage++;
      const filter = {
        count : this.count,
        page : this.propertyCurrentPage
      };
      if(this.searchPropertyKey){
        filter['filter.keyword'] = this.searchPropertyKey;
      }
      this.getAllProperties(filter);
    }else if(module === 'JOBS'){
      this.jobCurrentPage++;
      const filter = {
        'count': this.count,
        'page': this.jobCurrentPage,
        'filter.assigned_to': this.jobTabFilters.selectedUser || '',
        'filter.assigned_to_team': this.jobTabFilters.selectedTeam || ''
      };
      if(this.searchJobKey){
        filter['filter.keyword'] = this.searchJobKey;
      }
      this.getAllJobs(filter);
    }else if(module === 'ORGANIZATION'){
      this.organizationCurrentPage++;
      const filter = {
        count : this.count,
        page : this.organizationCurrentPage
      };
      if(this.searchOrganizationKey){
        filter['filter.keyword'] = this.searchOrganizationKey;
      }
      this.getAllOrganizations(filter);
    }
    else if(module === 'CUSTOMER'){
      this.customerCurrentPage++;
      const filter = {
        count : this.count,
        page : this.customerCurrentPage
      };
      if(this.searchCustomerKey){
        filter['filter.keyword'] = this.searchCustomerKey;
      }
      this.getAllCustomers(filter);
    }
    else if(module === 'ROUTES'){
      this.routesCurrentPage++;
      const filter = {
        limit : this.count,
        page : this.routesCurrentPage,
        from_date : this.currentFromRoutesDate,
        to_date : this.currentToRoutesDate
      };
      if(this.searchRouteKey){
        filter['filter.keyword'] = this.searchRouteKey;
      }
      this.getAllRoutes(filter);
    }
  }

  triggerRouteSearch(): void{
    this.routesCurrentPage = 1;
    const filter = {
      limit : this.count,
      page : this.routesCurrentPage,
      from_date : this.currentFromRoutesDate,
      to_date : this.currentToRoutesDate
    };
    if(this.searchRouteKey){
      filter['filter.keyword'] = this.searchRouteKey;
    }
    this._LocalStorageService.setLocalStorage('map_routes_filter', filter);
    this.getAllRoutes(filter);
  }

  getRoutesCount(date: any): void {
    const filter = {
      'from_date': date.startOf('month').format('YYYY-MM-DD'),
      'to_date': date.endOf('month').format('YYYY-MM-DD')
    };
    this._DataCollectorService.getData(this._MapService.mapsAPi.getRoutesCount, filter)
      .subscribe((res: any)=>{
        this.allRouteCount = res?.data;
        const calendarDates = document.querySelectorAll('.mat-calendar-body-cell-content');
        this.allRouteCount.forEach((route: any, i: number) =>{
          if(route?.job_routes > 0){
            calendarDates[i].classList.add('route-available');
          }else{
            calendarDates[i].classList.remove('route-available');
          }
        });
        this._changeDetectorRef.detectChanges();
      },(err: any) => {

      });
  }

  routeDateChange(): void {
    this.allRoutes = [];
    this.routesCurrentPage = 1;
    this.searchRouteKey = '';
    this.currentFromRoutesDate = this.searchDate.format('YYYY-MM-DD');
    this.currentToRoutesDate = this.searchDate.format('YYYY-MM-DD');
    const filter = {
      limit : this.count,
      page : this.routesCurrentPage,
      from_date : this.currentFromRoutesDate,
      to_date : this.currentToRoutesDate
    };
    this.getAllRoutes(filter);
  }


  getAllRoutes(filter): void{
    this.isLoading = true;
    this.showFilterBadge = false;
    this._DataCollectorService.getData(this._MapService.mapsAPi.getRoutes, filter)
      .subscribe((res)=>{
        this.routesFilterCount = 1; // Routes are filtered by date by default
        for(const key in filter){
          if((filter[key] && key === 'filter.keyword')){
            if(filter['filter.keyword']){
              this.routesFilterCount++;
            }
          }
        }
        if(this.routesCurrentPage > 1){
          this.allRoutes = [...this.allRoutes,...res.data];
        }else{
          this.allRoutes = res.data;
        };
        this._MapService.routeLocationData.next({
          state: 'listing',
          data: this.allRoutes
        });
        this.routesTotalPage = res['total_pages'];
        this.routesTotalRecords = res['total_records'];
        this.showFilterBadge = true;
        this.openNewRoute = false;
        this.currentRoute = null;
        this.isLoading = false;
      }, (err) => {
        this.isLoading = false;
      });
  }

  triggerCustomerSearch(): void{
    this.customerCurrentPage = 1;
    const filter = {
      count: this.count,
      page: 1
    };
    if(this.searchCustomerKey){
      filter['filter.keyword'] = this.searchCustomerKey;
    }
    this._LocalStorageService.setLocalStorage('map_customer_filter', filter);

    this.getAllCustomers(filter);
  }

  getAllCustomers(filter): void{
    this.isLoading = true;
    this.showFilterBadge = false;
    this._DataCollectorService.getData(this._MapService.mapsAPi.getCustomers, filter)
      .subscribe((res)=>{
        this.customerFilterCount = 0;
        for(const key in filter){
          if((filter[key] && key === 'filter.keyword')){
            if(filter['filter.keyword']){
              this.customerFilterCount++;
            }
          }
        }
        if(this.customerCurrentPage > 1){
          this.allCustomers = [...this.allCustomers,...res.data];
        }else{
          this.allCustomers = res.data;
        };
        this.allCustomers = this.allCustomers.map((customer: any) => {
          if (_.isNil(customer?.hasValidGeoCords)) {
            customer['hasValidGeoCords'] = this._utilityService.isValidGeoCords(customer?.customer_address?.geo_cordinates)
          }
          return customer;
        });
        this._MapService.customerLocationData.next(this.allCustomers);
        this.customerTotalPage = res['total_pages'];
        this.customerTotalRecords = res['total_records'];
        this.showFilterBadge = true;
        this.isLoading = false;
      }, (err) => {
        this.isLoading = false;
      });
  }

  triggerOrganizationSearch(): void{
    this.organizationCurrentPage = 1;
    const filter = {
      count: this.count,
      page: 1
    };
    if(this.searchOrganizationKey){
      filter['filter.keyword'] = this.searchOrganizationKey;
    }
    this._LocalStorageService.setLocalStorage('map_organization_filter', filter);
    this.getAllOrganizations(filter);
  }

  getAllOrganizations(filter): void{
    this.isLoading = true;
    this.showFilterBadge = false;
    this._DataCollectorService.getData(this._MapService.mapsAPi.getOrganizations,filter)
      .subscribe((res: any)=>{
        this.organizationFilterCount = 0;
        for(const key in filter){
          if((filter[key] && key === 'filter.keyword')){
            if(filter['filter.keyword']){
              this.organizationFilterCount++;
            }
          }
        }
        if(this.organizationCurrentPage > 1){
          this.allOrganizations = [...this.allOrganizations,...res.data];
        }else{
          this.allOrganizations = res.data;
        }
        this.allOrganizations = this.allOrganizations.map((org: any) => {
          if (_.isNil(org?.hasValidGeoCords)) {
            org['hasValidGeoCords'] = this._utilityService.isValidGeoCords(org?.organization_address?.geo_cordinates)
          }
          return org;
        });
        this._MapService.organizationLocationData.next(this.allOrganizations);

        this.organizationTotalPage = res['total_pages'];
        this.organizationTotalRecords = res['total_records'];
        this.isLoading = false;
        this.showFilterBadge = true;
      }, (err) =>{
        this.isLoading = false;
      });
  }

  triggerJobSearch(): void{
    this.jobCurrentPage = 1;
    const filter = {
      'count': this.count,
      'page': 1,
      'filter.assigned_to': this.jobTabFilters.selectedUser || '',
      'filter.assigned_to_team': this.jobTabFilters.selectedTeam || ''
    };
    if(this.searchJobKey){
      filter['filter.keyword'] = this.searchJobKey;
    }
    this._LocalStorageService.setLocalStorage('map_job_filter', filter);
    this.getAllJobs(filter);
  }

  getJobTabTeamSummary(jobFilters: any, init: boolean = false): void {
    const params = { 'page': this.jobTabFilters.teamsCurrentPage, 'filter.keyword': this.jobTabFilters.teamsSearchKeywoard || '', 'filter.team_uid': this.jobTabFilters.teamFilterUid };
    this.jobTabFilters.isLoading.teams = true;
    this._DataCollectorService.getData(this._MapService.mapsAPi.getTeamSummary, params)
    .subscribe((response: any) => {
      const teams = response?.data || [];
      if(init) {
        if(teams.length === 0) {
          this.handleTeamDelete(params);
        }
        else {
          jobFilters['filter.assigned_to_team'] = this.jobTabFilters.selectedTeam || '';
          this.getJobTabUsers(this.jobTabFilters.selectedTeam, jobFilters, true);
        }
      }
      if(teams.length > 0) {
        const updatedTeams = [...this.jobTabFilters.allTeams, ...teams];
        this.jobTabFilters.allTeams = _.uniqBy(updatedTeams, 'team_uid');
      }
      this.jobTabFilters.teamsCurrentPage = response?.current_page || 1;
      this.jobTabFilters.teamsTotalPages = response?.total_pages || 1;
      this.jobTabFilters.isLoading.teams = false;
    },
    (error: any) => {
      this.jobTabFilters.allTeams = [];
      this.jobTabFilters.isLoading.teams = false;
    });
  }

  handleTeamDelete(teamParams: any): void {
    teamParams['filter.team_uid'] = '';
    this.jobTabFilters.selectedUser = null;
    this.jobTabFilters.selectedTeam = null;
    if(!this.jobTabFilters.teamsResetBlocker) {
      this.jobTabFilters.teamsResetBlocker = true;
      this.getJobTabTeamSummary(teamParams, true);
    }
  }

  onJobTabTeamPickerOpen(): void {
    if (this.jobTabFilters.teamFilterUid) {
      this.jobTabFilters.teamsCurrentPage = 1;
      this.jobTabFilters.teamFilterUid = '';
      this.jobTabFilters.teamsSearchKeywoard = '';
      this.getJobTabTeamSummary(null);
    }
  }

  getJobTabUsers(teamUid: any, jobFilters: any, init: boolean = false): void {
    if (!teamUid) {
      if(init) {
        this.getAllJobs(jobFilters);
      }
      return;
    }
    const getUsersUrl = `${this._DataCollectorService.baseurl()}/team/${teamUid}`;
    this.jobTabFilters.isLoading.users = true;
    this._DataCollectorService.getData(getUsersUrl).subscribe((response) => {
      const allUsers = response?.data?.users || [];
      this.jobTabFilters.allUsers = allUsers?.map((user: any) => ({...user, user_name: _.compact([user.first_name, user.last_name]).join(' ')}));
      const isUserAvailable = _.find(this.jobTabFilters.allUsers, {'user_uid': this.jobTabFilters.selectedUser});
      if(!isUserAvailable) {
        this.jobTabFilters.selectedUser = null;
      }
      if(init) {
        jobFilters['filter.assigned_to'] = this.jobTabFilters.selectedUser || '';
        this.getAllJobs(jobFilters);
      }
      this.jobTabFilters.isLoading.users = false;
    },
    (error: any) => {
      this.jobTabFilters.allUsers = [];
      this.jobTabFilters.isLoading.users = false;
    });
  }

  onJobTabTeamSearch(): void {
    if (this.jobTabFilters.teamsCurrentPage !== this.jobTabFilters.teamsTotalPages || this.jobTabFilters.selectedTeam) {
      this.jobTabTeamSearchSubscription = this.jobTeamFilterSubject.pipe(
        distinctUntilChanged(),
        debounceTime(500)).subscribe((term: any) => {
          this.jobTabFilters.teamsSearchKeywoard = term;
          this.jobTabFilters.teamsCurrentPage = 1;
          this.jobTabFilters.selectedTeam = null;
          if (term?.trim().length === 0) {
            this.jobTabFilters.teamsSearchKeywoard = '';
          }
          this.jobTabFilters.allTeams = [];
          this.getJobTabTeamSummary(null);
        });
    }
  }

  onJobTabTeamChange(): void {
    const jobFilter = this.jobTabFilters.jobFilter;
    jobFilter['filter.assigned_to_team'] = this.jobTabFilters.selectedTeam || '';
    jobFilter['page'] = 1;
    this.jobCurrentPage = 1;
    if(!this.jobTabFilters.selectedTeam) {
      this.jobTabFilters.allUsers = [];
    }
    this.jobTabFilters.selectedUser = null;
    this.saveJobTabFilter('filter.assigned_to_team', this.jobTabFilters.selectedTeam);
    this.saveJobTabFilter('filter.assigned_to', this.jobTabFilters.selectedUser);
    this.getAllJobs(jobFilter);
    this.getJobTabUsers(this.jobTabFilters.selectedTeam, null);
  }

  onJobTabUserChange(): void {
    const jobFilter = this.jobTabFilters.jobFilter;
    jobFilter['filter.assigned_to'] = this.jobTabFilters.selectedUser || '';
    jobFilter['page'] = 1;
    this.jobCurrentPage = 1;
    this.saveJobTabFilter('filter.assigned_to', this.jobTabFilters.teamFilterUid);
    this.getAllJobs(jobFilter);
  }

  onJobTabTeamPickerScrollToEnd(): void {
    if(this.jobTabFilters.teamsCurrentPage < this.jobTabFilters.teamsTotalPages) {
      this.jobTabFilters.teamsCurrentPage += 1;
      this.getJobTabTeamSummary(null);
    }
  }

  saveJobTabFilter(key: any, value: any): void {
    if(!key) { return; }
    const mapJobTabFilters = this._LocalStorageService.getLocalStorage('map_job_filter') || {};
    mapJobTabFilters[key] = value;
    this._LocalStorageService.setLocalStorage('map_job_filter', mapJobTabFilters);
  }

  getAllJobs(filter): void{
    if(this.searchJobKey){
      filter['filter.keyword'] = this.searchJobKey;
    }
    this.isLoading = true;
    this.showFilterBadge = false;
    this.jobTabFilters.jobFilter = filter;
    this._DataCollectorService.getData(this._MapService.mapsAPi.getJobs, filter)
      .subscribe((res)=>{
        this._LocalStorageService.setLocalStorage('map_job_filter', filter);
        this.jobFilterCount = 0;
        for(const key in filter){
          if(this.jobFilterParams.includes(key) && filter[key]){
              this.jobFilterCount++;
          }
        }
        if(this.jobCurrentPage > 1){
          this.allJobs = [...this.allJobs,...res.data];
        }else{
          this.allJobs = res.data;
        }
        this.allJobs = this.allJobs.map((job: any) => {
          if (_.isNil(job?.hasValidGeoCords)) {
            job['hasValidGeoCords'] = this._utilityService.isValidGeoCords(job?.customer_address?.geo_cordinates)
          }
          return job;
        });
        if(this.count > 20){
          this.jobCurrentPage = Math.floor(this.count / 20);
          this.count = 20;
        }
        this._MapService.jobLocationData.next(this.allJobs);
        if(this.jobCurrentPage === 1){
          this.jobListing.nativeElement.scrollTop = 0;
        }
        this.isLoading = false;
        this.showFilterBadge = true;
        this.jobTotalPages = res['total_pages'];
        this.jobTotalRecords = res['total_records'];
      }, (err)=>{
        this.isLoading = false;
        if(err?.data?.message){

        }
      });
  }

  triggerPropertySearch(): void{
    this.propertyCurrentPage = 1;
    const filter = {
      count: this.count,
      page: 1
    };
    if(this.searchPropertyKey){
      filter['filter.keyword'] = this.searchPropertyKey;
    }
    this._LocalStorageService.setLocalStorage('map_property_filter', filter);
    this.getAllProperties(filter);
  }

  getAllProperties(filter): void{
    this.isLoading = true;
    this.showFilterBadge = false;
    this._DataCollectorService.getData(this._MapService.mapsAPi.getProperty, filter)
      .subscribe((res)=>{
        this.propertyFilterCount = 0;
        for(const key in filter){
          if((filter[key] && key === 'filter.keyword')){
            if(filter['filter.keyword']){
              this.propertyFilterCount++;
            }
          }
        }
        if(this.propertyCurrentPage > 1){
          this.allProperties = [...this.allProperties,...res.data];
        }else{
          this.allProperties = res.data;
        }
        this.allProperties = this.allProperties.map((property: any) => {
          if (_.isNil(property?.hasValidGeoCords) ) {
            property['hasValidGeoCords'] = this._utilityService.isValidGeoCords(property?.property_address?.geo_cordinates)
          }
          return property;
        });
        this._MapService.propertyLocationData.next(this.allProperties);
        if(this.propertyCurrentPage === 1){
          this.propertyListing.nativeElement.scrollTop = 0 ;
        }
        this.isLoading = false;
        this.showFilterBadge = true;

        this.propertyTotalPage = res.total_pages;
        this.propertyTotalRecords = res.total_records;
      });
  }

  getAssetCategory(): void{
    this._DataCollectorService.getData(this._MapService.mapsAPi.getAssetCategory)
      .subscribe((res)=>{
        this.allAssetCategory = res.data;
      }, (err) =>{

      });
  }

  categorySelected(event): void{
    this.allAssets = [];
    this.assetCurrentPage = 1;
    let filter;
    if(event){
      filter = {
        'filter.asset_category' : event,
        'count' : this.count,
        'page': this.assetCurrentPage
      };
    }else{
      filter = {
        count : this.count,
        page: this.assetCurrentPage
      };
    }
    this._LocalStorageService.setLocalStorage('map_asset_filter', filter);

    this.getAllAssets(filter);
  }

  triggerAssetSearch(): void{
    const filter = {
      count: this.count,
      page: 1
    };
    if(this.selectedAssetCategory){
      filter['filter.asset_category'] = this.selectedAssetCategory;
    }
    this.assetCurrentPage = 1;
    this.getAllAssets(filter);
  }

  getAllAssets(filter): void{
    if(this.searchAssetKey){
      filter['filter.keyword'] = this.searchAssetKey;
    }
    this._LocalStorageService.setLocalStorage('map_asset_filter', filter);
    this.isLoading = true;
    this.showFilterBadge = false;
    this._DataCollectorService.getData(this._MapService.mapsAPi.getAssets, filter)
      .subscribe((res)=>{
        this.assetFilterCount = 0;
        for(const key in filter){
          if((filter[key] && key === 'filter.asset_category') || (filter[key] && key === 'filter.keyword')){
            if(filter['filter.asset_category'] || filter['filter.keyword']){
              this.assetFilterCount++;
            }
          }
        }
        if(this.assetCurrentPage > 1){
          this.allAssets = [...this.allAssets,...res.data];
        }else{
          this.allAssets = res.data;
        }
        this.allAssets = this.allAssets.map((asset: any) => {
          if (_.isNil(asset?.hasValidGeoCords) ) {
            asset['hasValidGeoCords'] = this._utilityService.isValidGeoCords(asset?.asset_location?.geo_cordinates)
          }
          return asset;
        });
        this._MapService.assetLocationData.next(this.allAssets);
        if(this.assetCurrentPage === 1 && this.assetListing?.nativeElement?.scrollTop){
          this.assetListing.nativeElement.scrollTop = 0;
        }
        this.isLoading = false;
        this.showFilterBadge = true;
        this.assetTotalPage = res['total_pages'];
        this.assetTotalRecords = res['total_records'];
      }, (err)=>{
        this.isLoading = false;

      });
  }

  sendUserData(user): void{
    if(user?.user_uid)
    {
      if(user?.location_data?.latitude && user?.location_data?.longitude){
        this.mapview.emit(user);
      } else {
        this._toast.error(this._utilityService.getLocaleValue('maps.employee_location_data_not_found'));
      }
    };
  }

  sendAssetData(asset): void{
    if(asset?.asset_location?.geo_cordinates?.length > 0){
      this.mapview.emit(asset);
    }else{
      this._toast.error(this._utilityService.getLocaleValue('maps.asset_location_data_not_found'));
    }
  }

  sendPropertyData(property): void{
    if(property?.property_address?.geo_cordinates?.length > 0){
      this.mapview.emit(property);
    }else{
      this._toast.error(this._utilityService.getLocaleValue('maps.property_location_data_not_found'));
    }
  }

  sendJobData(job): void{
    if(job?.customer_address?.geo_cordinates?.length > 0){
      this.mapview.emit(job);
    }else{
      this._toast.error(this._utilityService.getLocaleValue('maps.job_location_data_not_found'));
    }
  }

  sendOrganizationData(organization): void{
    if(organization?.organization_address?.geo_cordinates?.length > 0){
      this.mapview.emit(organization);
    }else{
      this._toast.error(this._utilityService.getLocaleValue('maps.organization_location_data_not_found'));
    }
  }

  sendCustomerData(customer): void {
    if(customer?.customer_address?.geo_cordinates?.length > 0){
      this.mapview.emit(customer);
    }else{
      this._toast.error(this._utilityService.getLocaleValue('maps.customer_location_data_not_found'));
    }
  }

  viewHistory(data): void {
    const historyDialog = this._zuperDialogService.openCustom(ViewHistoryComponent,{
      data: {
        user: data,
        title: this._utilityService.getLocaleValue('maps.header.show_history') + ` ${data?.first_name} ${data?.last_name}`
      }
    });

    historyDialog.afterClosed().subscribe(
      (res: any) => {
        if(!this._utilityService.isEmptyOrUndefined(res)){
          this._router.navigate(['maps', data?.user_uid, 'history'],{
            queryParams: {
              'date': moment(res).format('YYYY-MM-DD'),
            }
          });
        }
      }
    );
  }

  showPreview(data, module): void{
    if(data?.user_uid && module === 'USER'){
      const preview_data = {
        'uid' : data.user_uid,
        'module' : module
      };
      this._MapService.previewUid.next(preview_data);
    }else if(data?.asset_uid && module === 'ASSETS'){
      const preview_data = {
        'uid' : data.asset_uid,
        'module' : module
      };
      this._MapService.previewUid.next(preview_data);
    } else if (data?.property_uid && module === 'PROPERTY') {
      const preview_data = {
        'uid': data.property_uid,
        'module': module
      };
      this._MapService.previewUid.next(preview_data);
    } else if (data?.organization_uid && module === 'ORGANIZATION') {
      const preview_data = {
        'uid': data.organization_uid,
        'module': module
      };
      this._MapService.previewUid.next(preview_data);
    } else if(data?.customer_uid && module === 'CUSTOMER'){
      const preview_data = {
        'uid' : data.customer_uid,
        'module' : module
      };
      this._MapService.previewUid.next(preview_data);
    } else if(data?.job_uid && module === 'JOBS'){
      const preview_data = {
        'uid' : data.job_uid,
        'module' : 'JOB'
      };
      this._MapService.previewUid.next(preview_data);
    } else if(data?.route_uid && module === 'ROUTES') {
      this.currentRouteUid = data?.route_uid;
      this.toggleDetails = true;
      if(data?.start_location?.geo_cords?.length){
        this.mapview.emit(data);
      }
    }
  }

  routeDetailsEvent(event: any): void {
    if(event === true){
      this.toggleDetails = event;
    }
    if(event?.status === 'close'){
      this.getDuration();
      this._MapService.routeLocationData.next({
        state: 'listing',
        data: this.allRoutes,
        drawerClosed: true
      });
      if(event?.data){
          this._MapService.routeDetailChange.next(event?.data);
          this.toggleDetails = false;
          return;
      }
      this.currentRoute = null;
    } else if(event?.status === 'change'){
      if(event?.data){
          const found = this.allRoutes.findIndex((route: any) => (route?.route_uid === event?.data?.route_uid));
          if(found > -1){
            this.allRoutes[found] = event.data;
          }
          this._MapService.routeLocationData.next({
            state: 'details',
            data: [this.allRoutes[found]]
          });
      }
    } else if(event?.status === 'clone'){
      if(event?.data){
          this.allRoutes.unshift(event?.data);
      }
    } else if(event?.status === 'delete'){
      if(event?.data){
        const found = this.allRoutes.findIndex((route: any) => (route?.route_uid === event?.data?.route_uid));
        if(found > -1){
          this.allRoutes.splice(found, 1);
        }
      }
      this._MapService.routeLocationData.next({
        state: 'listing',
        data: this.allRoutes,
        drawerClosed: true
      });
      this.currentRoute = null;
      this.toggleDetails = false;
    } else if(event?.status === 'view') {
      this.mapview.emit(event?.data);
    }
  }

  assignTeams(): void{
    this.allTeams = this.allTeamsCopy.slice();
  }

  teamFilter(event): void{
    if(!event){
      this.assignTeams();
    }else{
      this.allTeams = this.allTeamsCopy.filter(ele=>ele.team_name.includes(event));
    }
  }

  toggleFilter(module): void{
    if(module === 'EMPLOYEE'){
      this.allTeams = this.allTeamsCopy.slice();
      this.employeeFilter  = !this.employeeFilter;
    }else if(module === 'ASSETS'){
      this.assetFilter = !this.assetFilter;
    }else if(module === 'PROPERTY'){
      this.propertyFilter = !this.propertyFilter;
    }else if(module === 'ORGANIZATION'){
      this.organizationFilter = !this.organizationFilter;
    }else if(module === 'JOBS'){
      this.jobFilter = !this.jobFilter;
    }else if(module === 'CUSTOMER'){
      this.customerFilter = !this.customerFilter;
    }else if(module === 'ROUTES'){
      this.routesFilter = !this.routesFilter;
    }
  }

  onTeamSelected(): void{
    this.allUsers = [];
    this.employeeCurrentPage = 1;
    setTimeout(()=>{
      if(this.employeeFilterRef?.nativeElement?.scrollTop > -1){
        this.employeeFilterRef.nativeElement.scrollTop = this.employeeFilterRef.nativeElement.scrollHeight;
      }
    },200);
    const filter = {
      limit: this.count,
      page: 1
    };

    if(this.searchEmployeeKey){
      filter['filter.keyword'] = this.searchEmployeeKey;
    }

    if(this.selectedTeam){
      filter['team_uid'] = this.selectedTeam;
    }
    filter['user_status'] = this.filterUserStatus;
    this._LocalStorageService.setLocalStorage('map_employee_filter', filter);

    this.getAllUsers(filter);
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  getEmployeeStatus(data): boolean | Object {
    let timeOffFlag = false;
    const timeoffArray = data?.timeoff;
    if(timeoffArray?.length > 0){
      for(let i= 0; i < data?.timeoff?.length; i++){
        if(timeoffArray[i]?.all_day){
          timeOffFlag = true;
          break;
        }else{
          const currentDateTime = new Date();
          timeOffFlag = dayjs(currentDateTime).isBetween(dayjs.utc(timeoffArray[i]['request_from']), dayjs.utc(timeoffArray[i]['request_to']),'minute', '[]');
          if(timeOffFlag){
            break;
          }
        }
      }
      if(timeOffFlag){
        return {
          key:'ON_LEAVE',
          value: 'On Leave'
        };
      }else{
        if(data?.location_data){
          return this._getIsOccupied(data);
        }else{
          return false;
        }
      };
    }else{
      if(data?.location_data){
        return this._getIsOccupied(data);
      }else{
        return false;
      }
    }
  }

  getEmployeeStatusClass(key: string): string{
    if(key==='ON_LEAVE'){
      return 'text-red-500';
    } else if (key === 'IS_OCCUPIED'){
      return 'text-blue-500';
    } else if (key === 'AVAILABLE'){
      return 'text-green-500';
    } else if (key === 'OUT_OF_WORK_HOUR'){
      return 'text-orange-500';
    }
  }

  getTeamSummary(): void{
    const count = 100;
    const page = 1;
    const filter = {
      count : count,
      page : page
    };
    this._DataCollectorService.getData(this._MapService.mapsAPi.getTeamSummary, filter)
      .subscribe((res)=>{
        this.allTeams = res.data;
        this.allTeamsCopy = res.data;
        this.isInitLoading = false;
        if(this._LocalStorageService.getLocalStorage('map_employee_filter')?.['team_uid']){
          this.selectedTeam = this._LocalStorageService.getLocalStorage('map_employee_filter')?.['team_uid'];
        }
        const employeeFilter = this._LocalStorageService.getLocalStorage('map_employee_filter') || {};
        let skipGetAllUsers: any = employeeFilter?.['team_uid'];
        if(this.allTeams.length) {
          if(!employeeFilter['team_uid']) {
            employeeFilter['team_uid'] = this.allTeams[0]?.team_uid;
            this._LocalStorageService.setLocalStorage('map_employee_filter', employeeFilter);
          }
          this.selectedTeam = employeeFilter['team_uid'];
        }
        if(!this.isUserDataLoadedInit && !skipGetAllUsers){
          this.getAllUsers(employeeFilter);
        }
        // if(this.allTeams.length > 0){
        //   this.selectedTeam = [this.allTeams[0]['team_uid']]
        //   this.multiTeamSelected()
        // }
      }, (err) =>{
        this.isInitLoading = false;
      });
  }

  getOnlineCount(filter: any): void{
    this._DataCollectorService.getData(this._MapService.mapsAPi.getOnlineCount, filter)
      .subscribe((res: any)=>{
        const countData = res['data'];
          this.onlineCount = countData?.count_by_user_status?.online || 0;
          this.offlineCount = countData?.count_by_user_status?.offline || 0;
      });
  }

  getAllUsers(filter: any, is_init?: boolean): void{
    if(!filter?.team_uid) { return; }
    this.isLoading = true;
    delete filter['user_status'];
    this._DataCollectorService.getData(this._MapService.mapsAPi.getUsers,filter)
      .subscribe((res)=>{
        this.isUserDataLoadedInit = true;
        this.isInitLoading = false;
        this.employeeFilterCount = 0;
        for(const key in filter){
          if((filter[key] && key === 'team_uid') || (filter[key] && key === 'filter.user_uid') || (filter[key] && key === 'filter.keyword')){
            this.employeeFilterCount++;
          }
        }
        this.employeeFilterCount = this.filterUserStatus !== 'ALL' ? this.employeeFilterCount + 1: this.employeeFilterCount;
        if(this.employeeCurrentPage > 1){
          this.allUsers = this.filterUserStatus === 'OFFLINE' ? [...this.allUsers,...res.data['user_data']].filter((locationData: any) => !this.onlineUserUids.includes(locationData?.user_uid)): [...this.allUsers,...res.data['user_data']];
          this.allOriginalUsers = this.allUsers.slice();
        }else{
          this.allUsers = this.filterUserStatus === 'OFFLINE' ? res.data['user_data'].filter((locationData: any) => !this.onlineUserUids.includes(locationData?.user_uid)): res.data['user_data'];
          this.allOriginalUsers = this.allUsers.slice();
        }
        if(res.data['user_data'].length) {
          if(filter?.['filter.keyword']){
            if(this.filterUserStatus === 'ALL') {
              this.onlineCount = this.allUsers.filter((userDetails: any) => userDetails?.location_data?.track_time).length;
              this.offlineCount = this.allUsers.length - this.onlineCount;
            }
            else {
              this.offlineCount = this.allUsers.length;
            }
          }
          else {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            (filter?.team_uid) ? this.getOnlineCount({'team_uid':filter['team_uid']}) : this.getOnlineCount({});
          }
        }
        else {
          this.onlineCount = 0;
          this.offlineCount = 0;
        }
        this._MapService.employeeLocationData.next(this.allUsers);
        this.isLoading = false;
        this.employeeTotalPage = res.total_page;
        this.employeeTotalRecords = res.total_records;
        this.showFilterBadge = true;
        if(this.employeeCurrentPage === 1 && this.employeeListing?.nativeElement?.scrollTop){
          this.employeeListing.nativeElement.scrollTop = 0;
        }
      }, (err) => {
        this.isInitLoading = false;
      });
  }

  triggerEmployeeSearch(): void{
    const filter = {
      'filter.keyword' : this.searchEmployeeKey,
      'limit': this.count,
      'page': 1
    };
    if(this.selectedTeam){
      filter['team_uid'] = this.selectedTeam;
    }
    if(this.onlineUsers){
      filter['filter.user_uid'] = this.onlineUsers;
    }
    filter['user_status'] = this.filterUserStatus;
    this._LocalStorageService.setLocalStorage('map_employee_filter', filter);
    this.employeeCurrentPage = 1;
    if(!this.searchEmployeeKey){
      this.onUserFilterChange();
      this.onlineCount = 0;
      this.offlineCount = 0;
    }else{
      this.onUserFilterChange();
    }
  }

  displayFn(team): string{
    return this.allTeams.find(t=>t.team_uid === team)?.team_name;
  }

  updateList(): void {
    this.updateListSubscription = this._MapService.updateList.subscribe(
      (res: any) => {
        if(res?.module === 'JOB'){
          this.count = this.count * this.jobCurrentPage;
          this.jobCurrentPage = 1;
          let filter = {
            count : this.count,
            page : this.jobCurrentPage
          };
          const local_filter = this._LocalStorageService.getLocalStorage('map_job_filter');
          if(local_filter){
            filter = local_filter;
            if(local_filter?.['filter.keyword']){
              this.searchJobKey = local_filter['filter.keyword'];
            }
          }
          this.getAllJobs(filter);
        }
      }
    );
  }

  onUserFilterChange(): void {
    this.updateEmployeeFilter('user_status', this.filterUserStatus);
    this.onlineCount = 0;
    this.offlineCount = 0;
    if(this.filterUserStatus === 'ALL') {
      this.onTeamSelected();
    }
    else if(this.filterUserStatus === 'ONLINE') {
      this.getUserLocationData('ONLINE');
    }
    else if(this.filterUserStatus === 'OFFLINE') {
      this.getUserLocationData('OFFLINE');
    }
    this.updateFilterCount();
  }

  updateEmployeeFilter(key: string, value: any): void {
    if (!key) { return; }
    const filter = this._LocalStorageService.getLocalStorage('map_employee_filter');
    if (filter) {
      filter[key] = value;
      this._LocalStorageService.setLocalStorage('map_employee_filter', filter);
    }
  }

  updateFilterCount(): void {
    const filter = this._LocalStorageService.getLocalStorage('map_employee_filter');
    let filterCount = 0;
    for(const key in filter){
      if((filter[key] && key === 'team_uid') || (filter[key] && key === 'filter.user_uid') || (filter[key] && key === 'filter.keyword') || (filter[key] && key === 'user_status' && filter[key] !== 'All')){
        filterCount++;
      }
    }
    this.employeeFilterCount = filterCount;
    this.showFilterBadge = true;
  }

  getUserLocationData(type: 'ONLINE' | 'OFFLINE'): void {
    if(!this.selectedTeam) {return; }
    this.allUsers = [];
    this.isLoading = true;
    const param: any = { 'team_uid': this.selectedTeam };
    this._DataCollectorService.getData(this._MapService.mapsAPi.getLocation, param)
      .subscribe((response: any) => {
        this._MapService.employeeLocationData.next([]);
        this.onlineUserLocationData = response?.data || [];
        this.onlineUserLocationData = this.onlineUserLocationData.map((locationData: any) => ({ ...locationData.user, location_data: locationData }));
        this.onlineUserUids = this.onlineUserLocationData.map((onlineUserData: any) => (onlineUserData?.user_uid));
        if (type === 'ONLINE') {
          if (this.searchEmployeeKey.trim().length) {
            this.allUsers = this.onlineUserLocationData.filter((locationData: any) => (locationData?.first_name + locationData?.last_name).toLowerCase().includes((this.searchEmployeeKey.trim().toLowerCase())));
          }
          else {
            this.allUsers = this.onlineUserLocationData;
          }
          setTimeout(() => { this._MapService.employeeLocationData.next(this.allUsers); });
          this.onlineCount = this.allUsers.length;
          this.isLoading = false;
        }
        if(type === 'OFFLINE') {
          this.onTeamSelected();
        }
      },
      (error: any) => {
        this.allUsers = [];
        this.onlineCount = 0;
        this.offlineCount = 0;
        this.isLoading = false;
        this.onTeamSelected();
      });
  }

  //Lifecycle Hooks
  ngOnInit(): void {
    this.dateFormat = this._utilityService.dateFormat;
    this.companyConfig = this._LocalStorageService.getLocalStorage('company_configuration_data');
    this.updateList();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((res)=>{
        this._MapService.tab.next('EMPLOYEE');
        this.isInitLoading = true;
        dayjs.extend(isBetween);
        const localMarkerStatus = this._LocalStorageService.getLocalStorage('maps_marker_status');
        if(localMarkerStatus){
          this.markerStatus = localMarkerStatus.states;
        }
        this._MapService.prevTab = null;
        this.getTeamSummary();
        this.getTab();
      },(err)=>{
        this.isShown = false;
        this._zuperDialogService.open({
          title:`${this._utilityService.getLocaleValue('maps.alert.enable.geo_location.title','Geo-location service not enabled')}`,
          message:this._utilityService.getLocaleValue('maps.alert.enable_geo_location'),
          type:'error',
          actions    : {
              confirm: {
                show : true,
                label: 'Ok',
                color: 'primary',
                confirmDisplayKey:'text.ok',
              },
              cancel : {
                  show : false,
                  label: 'Cancel'
              }
          }
        });
      });
     }
  }

  getDuration(): any {
    this.allRoutes?.forEach((item) => {
      let totalJobDuration: number = 0;
      if (item?.jobs?.length && !item?.total_scheduled_duration) {
        item?.jobs.forEach((job) => {
          if (job?.job?.scheduled_duration) {
            totalJobDuration += job?.job?.scheduled_duration;
          }
        });
        item['total_scheduled_duration'] = totalJobDuration;
      }
    });
  }

  ngOnDestroy(): void {
    if(this.currentTabSubscription?.unsubscribe){
      this.currentTabSubscription.unsubscribe();
    }
    if(this.routeDetailSubscription?.unsubscribe){
      this.routeDetailSubscription.unsubscribe();
    }
    if(this.updateListSubscription?.unsubscribe){
      this.updateListSubscription?.unsubscribe();
    }
    this.jobTabTeamSearchSubscription?.unsubscribe();
  }

  getCustomerName(customerDetails: any): string {
    const customerName = [customerDetails?.customer_first_name, customerDetails?.customer_last_name];
    return _.compact(customerName).join(' ');
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  private _getIsOccupied(data): Object{
    dayjs.extend(isBetween);
    if(data?.location_data?.is_occupied){
      return {
        key : 'IS_OCCUPIED',
        value : this._utilityService.getLocaleValue('text.is_occupied', 'Is Occupied')
      };
    }else if(data?.work_hour){
      const currentDateTime = new Date();
      const isWorkHour = dayjs(currentDateTime).isBetween(dayjs(data.work_hour.start_time,'HH:mm:ss'), dayjs(data.work_hour.end_time,'HH:mm:ss'));
      if(isWorkHour){
        return {
          key : 'AVAILABLE',
          value : this._utilityService.getLocaleValue('text.available', 'Available')
        };
      }else{
        return {
          key : 'OUT_OF_WORK_HOUR',
          value : this._utilityService.getLocaleValue('text.out_of_work','Out of Work')
        };
      }
    }else{
      return {
        key : 'AVAILABLE',
        value : this._utilityService.getLocaleValue('text.available', 'Available')
      };
    }
  }
}
